var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.resData)?_c('div',[_c('highcharts',{attrs:{"options":_vm.resData}})],1):_c('div',{staticClass:"mt-4 ml-2"},[_vm._v("No data available in chart!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }